<mat-card
  (click)="onCardClick()"
  (keydown.enter)="onCardClick()"
  role="button"
  tabindex="0"
  attr.aria-label="Click to read more about {{ title }}"
  class="flex h-full flex-col cursor-pointer transition-shadow duration-300 hover:shadow-xl"
>
  <img
    mat-card-image
    [src]="image"
    [alt]="altText"
    class="aspect-video w-full shrink-0 object-cover"
  />

  <mat-card-content class="flex w-full grow flex-col p-4">
    <h3 class="text-lg font-semibold leading-tight mt-2">
      {{ title }}
    </h3>

    <p class="mt-1 text-sm text-gray-600">
      {{ secondaryText }}
    </p>

    <div class="grow"></div>

    <div *ngIf="states" class="mt-2 flex items-center gap-4 text-sm text-gray-500">
      <div *ngIf="states.likes" class="flex items-center gap-1">
        <mat-icon class="text-base">favorite_border</mat-icon>
        <span>{{ states.likes }}</span>
      </div>

      <div *ngIf="states.comments" class="flex items-center gap-1">
        <mat-icon class="text-base">chat_bubble_outline</mat-icon>
        <span>{{ states.comments }}</span>
      </div>

      <div *ngIf="states.views" class="flex items-center gap-1">
        <mat-icon class="text-base">visibility</mat-icon>
        <span>{{ states.views }}</span>
      </div>
    </div>
  </mat-card-content>
</mat-card>